<div *ngFor="let appointment of appointments; trackBy: trackByAppointmentId" 
     class="flex flex-col xl:flex-row border border-gray-200 p-3 rounded-xl relative card-scale">

  <div class="relative pr-0 xl:pr-4 pb-2">
    <div class="rounded-lg overflow-hidden w-full md:lg-0">
      <img class="card-img" [src]="assetUrl + 'img/mock-salon1.png'" />
    </div>
    <div class="absolute top-3 left-[-6px]">
      <span class="absolute top-0 left-0 w-[6px] h-1 -top-1.5 rounded-tl-[6px] rounded-bl-[6px] bg-mid-purple"> </span>
      <span class="px-2 py-1 rounded-tl rounded-tr-[99px] rounded-br-[99px] rounded-bl text-xs text-purple bg-light-purple">
        Popular
      </span>
    </div>
  </div>

  <div class="flex justify-between flex-1" [ngClass]="[mode === modes.favorite ? 'items-start' : '']">
    <div class="flex flex-col gap-3 whitespace-nowrap">
      <h4 class="pb-3 text-md font-semibold">
        {{ appointment.salon.name || "Salon Name Not Available" }}
      </h4>

      <div class="flex items-center text-gray-600 text-sm">
        <img [src]="assetUrl + 'icons/marker-lg.svg'" class="mr-[2px]" />
        <span>{{ appointment.salon.address }} {{ appointment.salon.city }}</span>
      </div>

      <div class="flex items-center text-gray-600 text-sm">
        <img [src]="assetUrl + 'icons/calendar.svg'" class="mr-[2px]"/>
        <span>{{ formatDateTime(appointment.start_time) }}</span>
      </div>

      <div *ngIf="mode === modes.overview" class="flex text-gray-900 text-sm pt-1 items-center flex-wrap">
        <span class="text-md font-semibold pr-2 order-2 md:order-1">
          {{ formatPrice(appointment.total_price) }}
        </span>
        <glo-tag 
          [text]="getTagText(appointment)" 
          [state]="getTagState(appointment)"  
          class="order-1 md:order-2 mr-2">
        </glo-tag>
      </div>
    </div>

    <div *ngIf="mode === modes.overview" class="flex items-end lg:items-center">
      <a routerLink="salon">
        <button class="ml-3 px-6 py-2 shadow rounded-3xl bg-gray-950 text-xs md:text-md text-white whitespace-nowrap">
          See Details
        </button>
      </a>
    </div>

    <div *ngIf="mode === modes.favorite" class="flex absolute top-5 right-5 xl:relative xl:top-0 xl:right-0">
      <img [src]="assetUrl + 'icons/favorite-red.svg'" >
    </div>
  </div>
</div>
